type FileNames = Record<string, string>;
type FileExtensions = Record<string, string>;

const PANEL_ICON_SVGS: Record<string, string> = {
    file: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 2H3.99973C2.89516 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12V7H11C9.89543 7 9 6.10457 9 5V2Z" fill="#414243"/><path d="M11 6H14L10 2V5C10 5.55228 10.4477 6 11 6Z" fill="#414243" /></svg>`,
    c: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89504 2 3.99961 2H8H12.0004C13.105 2 14 2.89543 14 4ZM5.44275 11.1565C5.89313 11.3855 6.39313 11.5 6.94275 11.5C7.48473 11.5 7.95038 11.4046 8.33969 11.2137C8.72901 11.0229 9.04198 10.7634 9.27863 10.4351C9.4233 10.2362 9.54253 10.0252 9.63633 9.80219C9.74393 9.54636 9.57397 9.27215 9.30395 9.20797L8.91777 9.11617C8.63606 9.0492 8.36589 9.24191 8.23706 9.50124C8.16531 9.64568 8.07356 9.77376 7.96183 9.8855C7.74046 10.1069 7.41221 10.2176 6.9771 10.2176C6.68702 10.2176 6.42366 10.1565 6.18702 10.0344C5.95802 9.90458 5.77481 9.71756 5.6374 9.47328C5.50763 9.22137 5.44275 8.91603 5.44275 8.55725V8.44275C5.44275 8.08397 5.50763 7.78244 5.6374 7.53817C5.77481 7.28626 5.95802 7.09924 6.18702 6.9771C6.42366 6.84733 6.68702 6.78244 6.9771 6.78244C7.26718 6.78244 7.50763 6.83588 7.69847 6.94275C7.89695 7.04962 8.04962 7.19466 8.15649 7.37786C8.17591 7.41116 8.19407 7.4452 8.21097 7.48001C8.33824 7.74213 8.60603 7.9443 8.89102 7.88357L9.28504 7.7996C9.54938 7.74326 9.72623 7.4844 9.63287 7.23075C9.54627 6.99544 9.42818 6.77731 9.27863 6.57634C9.04198 6.24046 8.72901 5.9771 8.33969 5.78626C7.95038 5.59542 7.48473 5.5 6.94275 5.5C6.39313 5.5 5.89313 5.6145 5.44275 5.84351C5 6.07252 4.64885 6.40458 4.38931 6.83969C4.12977 7.27481 4 7.80153 4 8.41985V8.58015C4 9.19847 4.12977 9.72519 4.38931 10.1603C4.64885 10.5954 5 10.9275 5.44275 11.1565Z" fill="#7886FF"/></svg>`,
    'c-h': `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89504 2 3.99961 2H8H12.0004C13.105 2 14 2.89543 14 4ZM4.5 11.0438C4.5 11.3199 4.72386 11.5438 5 11.5438H5.26787C5.54402 11.5438 5.76788 11.3199 5.76788 11.0438V9.008C5.76788 8.54513 5.87521 8.18623 6.08988 7.93131C6.30454 7.66969 6.60642 7.53888 6.9955 7.53888C7.33763 7.53888 7.59925 7.63279 7.78038 7.82063C7.96821 8.00846 8.06213 8.29021 8.06213 8.66588V11.0438C8.06213 11.3199 8.28598 11.5438 8.56212 11.5438H8.83C9.10614 11.5438 9.33 11.3199 9.33 11.0438V8.56525C9.33 8.14933 9.2495 7.78708 9.0885 7.4785C8.9275 7.16321 8.69942 6.91835 8.40425 6.74394C8.11579 6.56281 7.77702 6.47225 7.38794 6.47225C7.09277 6.47225 6.84792 6.50915 6.65337 6.58294C6.46554 6.65002 6.3146 6.73723 6.20056 6.84456C6.08652 6.9519 6.00267 7.05923 5.949 7.16656H5.76788V5C5.76788 4.72386 5.54402 4.5 5.26788 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V11.0438Z" fill="#7886FF"/></svg>`,
    xml: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89504 2 3.99961 2H8H12.0004C13.105 2 14 2.89543 14 4ZM7.44714 6.51712C7.73274 6.21711 7.72106 5.74238 7.42105 5.45678C7.12104 5.17118 6.64631 5.18287 6.36071 5.48288L4.45678 7.48289C4.18107 7.77251 4.18107 8.2275 4.45678 8.51713L6.36067 10.5171C6.64627 10.8171 7.121 10.8288 7.42101 10.5432C7.72102 10.2576 7.73271 9.78289 7.44711 9.48288L6.03549 8.00001L7.44714 6.51712ZM9.63929 5.48288C9.35369 5.18287 8.87896 5.17118 8.57895 5.45678C8.27894 5.74238 8.26726 6.21711 8.55286 6.51712L9.96451 8.00001L8.55289 9.48288C8.26729 9.78289 8.27898 10.2576 8.57899 10.5432C8.879 10.8288 9.35373 10.8171 9.63933 10.5171L11.5432 8.51713C11.8189 8.2275 11.8189 7.77251 11.5432 7.48289L9.63929 5.48288Z" fill="#E495C0"/></svg>`,
    json: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0004 2C13.105 2 14 2.89543 14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89504 2 3.99961 2H8H12.0004ZM5.90391 4.25C5.4897 4.25 5.15391 4.58578 5.15391 5L5.15389 7.25H5C4.58579 7.25 4.25 7.58579 4.25 8C4.25 8.41421 4.58579 8.75 5 8.75H5.15389V11C5.15389 11.4142 5.48968 11.75 5.90389 11.75H6.90389C7.3181 11.75 7.65389 11.4142 7.65389 11C7.65389 10.5858 7.3181 10.25 6.90389 10.25H6.65389V8V8L6.6539 5.75H6.90393C7.31814 5.75 7.65393 5.41421 7.65393 5C7.65393 4.58579 7.31814 4.25 6.90393 4.25H5.90391ZM9.09607 4.25C8.68186 4.25 8.34607 4.58579 8.34607 5C8.34607 5.41421 8.68186 5.75 9.09607 5.75H9.3461L9.34611 8V10.25H9.09611C8.6819 10.25 8.34611 10.5858 8.34611 11C8.34611 11.4142 8.6819 11.75 9.09611 11.75H10.0961C10.5103 11.75 10.8461 11.4142 10.8461 11V8.75H11C11.4142 8.75 11.75 8.41421 11.75 8C11.75 7.58579 11.4142 7.25 11 7.25H10.8461L10.8461 5C10.8461 4.58578 10.5103 4.25 10.0961 4.25H9.09607Z" fill="#D1C560"/></svg>`,
    image: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12V4C14 2.89543 13.105 2 12.0004 2H8H3.99961C2.89504 2 2 2.89543 2 4V12C2 12.4109 2.1239 12.7928 2.33637 13.1105L6.86869 9.62407C7.82827 8.88594 9.17885 8.94142 10.0747 9.75578L13.701 13.0525C13.8906 12.7468 14 12.3862 14 12ZM12.9769 13.7456L9.40198 10.4957C8.8645 10.0071 8.05415 9.97382 7.4784 10.4167L3.09856 13.7858C3.36943 13.9228 3.6757 14 4 14H12C12.3548 14 12.688 13.9076 12.9769 13.7456ZM7.5 5.75C7.5 6.7165 6.7165 7.5 5.75 7.5C4.7835 7.5 4 6.7165 4 5.75C4 4.7835 4.7835 4 5.75 4C6.7165 4 7.5 4.7835 7.5 5.75Z" fill="#EDAB6D"/></svg>`,
    font: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 4V12C14 13.1046 13.1046 14 12 14H4C2.89543 14 2 13.1046 2 12V4C2 2.89543 2.89504 2 3.99961 2H8H12.0004C13.105 2 14 2.89543 14 4ZM7.00001 10.9833H7.26667L7.26667 6.36666H5.35001V6.66667C5.35001 6.85996 5.19331 7.01666 5.00001 7.01666C4.80671 7.01666 4.65001 6.85996 4.65001 6.66667L4.65001 5.81923C4.6391 5.77012 4.63334 5.71906 4.63334 5.66666C4.63334 5.61426 4.6391 5.56321 4.65001 5.51409V5.33333C4.65001 5.14003 4.80672 4.98333 5.00001 4.98333C5.03959 4.98333 5.07764 4.9899 5.11311 5.00201C5.18236 4.97908 5.2564 4.96666 5.33334 4.96666H10.6667C10.7436 4.96666 10.8177 4.97908 10.8869 5.00201C10.9224 4.9899 10.9604 4.98333 11 4.98333C11.1933 4.98333 11.35 5.14003 11.35 5.33333V5.51412C11.3609 5.56323 11.3667 5.61427 11.3667 5.66666C11.3667 5.71905 11.3609 5.7701 11.35 5.8192V6.66667C11.35 6.85996 11.1933 7.01666 11 7.01666C10.8067 7.01666 10.65 6.85996 10.65 6.66667V6.36666H8.66667L8.66667 10.9833H9.00001C9.19331 10.9833 9.35001 11.14 9.35001 11.3333C9.35001 11.5266 9.19331 11.6833 9.00001 11.6833H7.00001C6.80671 11.6833 6.65001 11.5266 6.65001 11.3333C6.65001 11.14 6.80671 10.9833 7.00001 10.9833Z" fill="#A883F3"/></svg>`,
    system: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M14 12V4C14 2.89543 13.105 2 12.0004 2H8H3.99961C2.89504 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H12C13.1046 14 14 13.1046 14 12ZM12 10.5C12 10.9142 11.6642 11.25 11.25 11.25H9.00001C8.58579 11.25 8.25001 10.9142 8.25001 10.5C8.25001 10.0858 8.58579 9.75 9.00001 9.75L11.25 9.75C11.6642 9.75 12 10.0858 12 10.5ZM7.98789 8.53034C8.28078 8.23745 8.28078 7.76258 7.98789 7.46968L5.48786 4.96966C5.19497 4.67677 4.7201 4.67677 4.4272 4.96966C4.13431 5.26255 4.13431 5.73743 4.4272 6.03032L6.3969 8.00002L4.42725 9.96969C4.13436 10.2626 4.13436 10.7375 4.42726 11.0303C4.72015 11.3232 5.19502 11.3232 5.48792 11.0303L7.98789 8.53034Z" fill="#6FB6BE"/></svg>`,
    project: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.84615 2C2.82655 2 2 2.82655 2 3.84615L2 4.81319C2 5.15305 2.27551 5.42857 2.61538 5.42857H5.05494C5.73468 5.42857 6.28571 5.97961 6.28571 6.65934V9.08461C6.28571 9.42448 6.56123 9.7 6.90109 9.7H9.34065C10.0204 9.7 10.5714 10.251 10.5714 10.9308V13.3846C10.5714 13.7245 10.8469 14 11.1868 14H12.1538C13.1734 14 14 13.1734 14 12.1538V3.84615C14 2.82655 13.1734 2 12.1538 2H3.84615ZM12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5Z" fill="#E96F3A"/><rect x="2" y="6.28571" width="3.42857" height="3.42857" rx="0.615385" fill="#E96F3A"/><path d="M2 11.1868C2 10.8469 2.27552 10.5714 2.61538 10.5714H4.81319C5.15305 10.5714 5.42857 10.8469 5.42857 11.1868V13.3846C5.42857 13.7245 5.15305 14 4.81319 14H3.84615C2.82655 14 2 13.1734 2 12.1538V11.1868Z" fill="#E96F3A"/><rect x="6.28571" y="10.5714" width="3.42857" height="3.42857" rx="0.615385" fill="#E96F3A"/></svg>`,
    cmake: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.7794 14.0303C13.7468 14.0369 13.7131 14.042 13.6779 14.042H2.37513L5.25599 11.3174L13.7794 14.0303ZM8.41322 2.00488L14.0158 13.1035L10.2892 11.917L8.41224 2.00293L8.41322 2.00488ZM8.31166 7.03809L1.9347 13.0654L7.40248 2.23633L8.31166 7.03809ZM9.16713 11.5596L6.04896 10.5674L8.53431 8.2168L9.16713 11.5596Z" fill="#7886FF"/></svg>`,
    git: `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 3.75C4 2.7835 4.7835 2 5.75 2C6.7165 2 7.5 2.7835 7.5 3.75C7.5 4.46479 7.07152 5.0795 6.45747 5.35171L6.95188 6.83494C7.05708 7.15052 7.35242 7.36364 7.68505 7.36364H8.75C8.9433 7.36364 9.12989 7.39266 9.30565 7.44659C9.54386 6.74679 10.2066 6.24342 10.9865 6.24342C11.9672 6.24342 12.7622 7.03843 12.7622 8.01911C12.7622 8.99979 11.9672 9.7948 10.9865 9.7948C10.2066 9.7948 9.54386 9.29143 9.30565 8.59163C9.12989 8.64556 8.9433 8.67458 8.75 8.67458H7.68505C6.788 8.67458 5.99109 8.10011 5.70743 7.24913L5.32005 6.087L4.72439 8.16718C4.64483 8.4446 4.6039 8.73185 4.60251 9.02041C5.41743 9.23883 6.01852 9.98267 6.01852 10.8662C6.01852 11.9221 5.1626 12.778 4.10669 12.778C3.05078 12.778 2.19486 11.9221 2.19486 10.8662C2.19486 10.141 2.59862 9.51014 3.1933 9.18601C3.19253 8.71833 3.25692 8.25284 3.38586 7.80309L4.12175 5.23496C4.04346 5.0254 4 4.79852 4 4.56061V3.75ZM5.75 3.25C5.47386 3.25 5.25 3.47386 5.25 3.75V4.56061C5.25 4.83676 5.47386 5.06061 5.75 5.06061C6.02614 5.06061 6.25 4.83676 6.25 4.56061V3.75C6.25 3.47386 6.02614 3.25 5.75 3.25ZM10.4865 8.01911C10.4865 7.74297 10.7104 7.51911 10.9865 7.51911C11.2627 7.51911 11.4865 7.74297 11.4865 8.01911C11.4865 8.29525 11.2627 8.51911 10.9865 8.51911C10.7104 8.51911 10.4865 8.29525 10.4865 8.01911ZM3.44486 10.8662C3.44486 10.5013 3.74177 10.2044 4.10669 10.2044C4.47161 10.2044 4.76852 10.5013 4.76852 10.8662C4.76852 11.2311 4.47161 11.528 4.10669 11.528C3.74177 11.528 3.44486 11.2311 3.44486 10.8662Z" fill="#F05033"/></svg>`
};

const FILE_NAMES: FileNames = {
    'androidmanifest.xml': 'android',
    'bower.json': 'bower',
    'brunch-config.js': 'brunch',
    'brunch-config.ts': 'brunch',
    'brunch-config.coffee': 'brunch',
    'cmakelists.txt': 'cmake',
    'gitlab-ci.yaml': 'gitlab',
    'gitlab-ci.yml': 'gitlab',
    makefile: 'settings',
    rakefile: 'ruby',
    'docker-compose.yml': 'docker',
    dockerfile: 'docker',
    'dockerfile.environment': 'docker',
    'environment.dockerfile': 'docker',
    'nginx.dockerfile': 'docker',
    'gruntfile.js': 'grunt',
    'gruntfile.ts': 'grunt',
    'gruntfile.coffee': 'grunt',
    'gulpfile.js': 'gulp',
    'gulpfile.ts': 'gulp',
    'gulpfile.coffee': 'gulp',
    'gulpfile.babel.js': 'gulp',
    jenkinsfile: 'jenkinsfile',
    'karma.conf.js': 'karma',
    'karma.conf.ts': 'karma',
    'karma.conf.coffee': 'karma',
    license: 'license',
    licence: 'license',
    'license.md': 'license',
    'licence.md': 'license',
    'license.txt': 'license',
    copyright: 'license',
    'copyright.md': 'license',
    copying: 'license',
    'mocha.opts': 'mocha',
    'package.json': 'package_json',
    'package-lock.json': 'lock',
    'npm-debug.log': 'npm',
    'paket.references': 'paket',
    'paket.dependencies': 'paket',
    'paket.lock': 'lock',
    'paket.local': 'paket',
    gemfile: 'ruby',
    'project.xml': 'project',
    'gemfile.lock': 'lock',
    'vscodeignore.json': 'visualstudiocode',
    'extensions.json': 'visualstudiocode',
    'launch.json': 'visualstudiocode',
    'settings.json': 'visualstudiocode',
    'tasks.json': 'visualstudiocode',
    'jsconfig.json': 'json',
    'tsconfig.json': 'json',
    'yarn.lock': 'lock',
    'yarn-error.log': 'yarn',
    '.babelrc': 'babel',
    '.eslintrc.js': 'eslint',
    '.eslintrc.yml': 'eslint',
    '.eslintrc.yaml': 'eslint',
    '.eslintrc.json': 'eslint',
    '.gitlab-ci.yaml': 'gitlab',
    '.gitlab-ci.yml': 'gitlab',
    'rollup.config.js': 'rollup',
    'rollup.config.ts': 'rollup',
    'rollup.config.coffee': 'rollup',
    'prettierrc.js': 'prettier',
    'prettierrc.json': 'prettier',
    'prettierrc.yml': 'prettier',
    'prettierrc.yaml': 'prettier',
    'prettier.config.js': 'prettier',
    'prettier.config.ts': 'prettier',
    'prettier.config.coffee': 'prettier',
    'tslint.js': 'tslint',
    'tslint.ts': 'tslint',
    'tslint.json': 'tslint',
    'bsconfig.json': 'bucklescript',
    configure: 'shell',
    contributing: 'doc',
    install: 'doc',
    manifesto: 'doc',
    readme: 'doc',
    history: 'changelog',
    'history.md': 'changelog',
    changelog: 'changelog',
    'changelog.md': 'changelog',
    'changelog.json': 'changelog',
    'requirements.txt': 'pip_requirements',
    gradlew: 'shell'
};

const FILE_EXTENSIONS: FileExtensions = {
    ai: 'illustrator',
    as: 'actionscript',
    au3: 'autoit',
    htaccess: 'apache',
    htpasswd: 'apache',
    bin: 'binary',
    o: 'binary',
    lib: 'binary',
    dll: 'binary',
    obj: 'binary',
    a: 'binary',
    so: 'binary',
    pyc: 'binary',
    exe: 'exe',
    bowerrc: 'bower',
    c: 'c',
    h: 'c-h',
    cake: 'cake',
    kit: 'codekit',
    coffee: 'coffeescript',
    cfc: 'cfm',
    cfm: 'cfm',
    cfml: 'cfm',
    clj: 'clojure',
    cljs: 'clojure',
    cljc: 'clojure',
    edn: 'clojure',
    ctp: 'cakephp',
    lucee: 'coldfusion',
    cmake: 'cmake',
    'cmakelists.txt': 'cmake',
    cc: 'cpp',
    cpp: 'cpp',
    hpp: 'cpp-h',
    cxx: 'cpp',
    cs: 'csharp',
    cshtml: 'razor',
    csproj: 'visualstudio',
    css: 'css',
    dockerignore: 'docker',
    dockerfile: 'docker',
    'dockerfile.environment': 'docker',
    'environment.dockerfile': 'docker',
    dust: 'dust',
    ejs: 'ejs',
    eslintrc: 'eslint',
    eslintignore: 'eslint',
    ex: 'elixir',
    exs: 'elixir',
    eex: 'elixir',
    elm: 'elm',
    erl: 'erlang',
    hrl: 'erlang',
    emakefile: 'erlang',
    emakerfile: 'erlang',
    woff: 'font',
    woff2: 'font',
    ttf: 'font',
    otf: 'font',
    eot: 'font',
    pfa: 'font',
    pfb: 'font',
    feature: 'gherkin',
    fs: 'fsharp',
    fsproj: 'visualstudio',
    fsx: 'fsharp',
    fsi: 'fsharp',
    gitattributes: 'git',
    gitignore: 'git',
    gitmodules: 'git',
    gitkeep: 'git',
    go: 'go',
    gradle: 'gradle',
    gradlew: 'gradle',
    haml: 'haml',
    has: 'haskell',
    hs: 'haskell',
    lhs: 'haskell',
    lit: 'haskell',
    gf: 'haskell',
    hbs: 'handlebars',
    hx: 'haxe',
    hxml: 'haxe',
    htm: 'html',
    html: 'html',
    jpeg: 'image',
    jpg: 'image',
    gif: 'image',
    png: 'image',
    bmp: 'image',
    ico: 'image',
    jade: 'jade',
    pug: 'pug',
    java: 'java',
    jar: 'zip',
    js: 'javascript',
    es6: 'javascript',
    json: 'json',
    jl: 'julia',
    key: 'key',
    pub: 'key',
    pem: 'key',
    asc: 'key',
    ppk: 'key',
    less: 'less',
    liquid: 'liquid',
    md: 'markdown',
    markdown: 'markdown',
    mdx: 'markdown',
    mjml: 'mjml',
    fig: 'matlab',
    mat: 'matlab',
    mex: 'matlab',
    mexn: 'matlab',
    mexrs6: 'matlab',
    mn: 'matlab',
    mum: 'matlab',
    mx: 'matlab',
    mx3: 'matlab',
    rwd: 'matlab',
    slx: 'matlab',
    slddc: 'matlab',
    smv: 'matlab',
    tikz: 'matlab',
    xvc: 'matlab',
    mst: 'mustache',
    nconf: 'nginx',
    webmanifest: 'node',
    nuspec: 'nuget',
    nupkg: 'nuget',
    nunjucks: 'nunjucks',
    nunjs: 'nunjucks',
    nj: 'nunjucks',
    njhtml: 'nunjucks',
    njk: 'nunjucks',
    npmignore: 'npm',
    ml: 'ocaml',
    mll: 'ocaml',
    mli: 'ocaml',
    mly: 'ocaml',
    ocamlmakefile: 'ocaml',
    merlin: 'ocaml',
    pdf: 'pdf',
    postcss: 'postcss',
    postcssrc: 'postcss',
    pcss: 'postcss',
    perl: 'perl',
    pl: 'perl',
    pm: 'perl',
    php: 'php',
    php1: 'php',
    php2: 'php',
    php3: 'php',
    php4: 'php',
    php5: 'php',
    php6: 'php',
    phps: 'php',
    phpsa: 'php',
    phpt: 'php',
    phtml: 'php',
    phar: 'php',
    ps1: 'powershell',
    psc1: 'powershell',
    psm1: 'powershell',
    ps1xml: 'powershell',
    psd1: 'powershell',
    pssc: 'powershell',
    psd: 'photoshop',
    py: 'python',
    pyw: 'python',
    jsx: 'javascript-react',
    tsx: 'typescript-react',
    r: 'rlang',
    R: 'rlang',
    RData: 'rlang',
    rda: 'rlang',
    rds: 'rlang',
    rprofile: 'rlang',
    Rprofile: 'rlang',
    rb: 'ruby',
    erb: 'ruby',
    gemfile: 'ruby',
    gemspec: 'ruby',
    rs: 'rust',
    scala: 'scala',
    sass: 'sass',
    scss: 'sass',
    sss: 'postcss',
    sln: 'visualstudio',
    suo: 'visualstudio',
    slim: 'slim',
    env: 'settings',
    ini: 'settings',
    makefile: 'settings',
    rake: 'ruby',
    rakefile: 'ruby',
    mk: 'settings',
    config: 'settings',
    conf: 'settings',
    cfg: 'settings',
    properties: 'settings',
    editorconfig: 'settings',
    bat: 'shell',
    sh: 'shell',
    cmd: 'shell',
    bash: 'shell',
    zsh: 'shell',
    fish: 'shell',
    'sublime-project': 'sublime',
    'sublime-workspace': 'sublime',
    sqlite: 'database',
    sql: 'database',
    db3: 'database',
    styl: 'stylus',
    stylus: 'stylus',
    svg: 'image',
    swift: 'swift',
    'test.js': 'javascript-test',
    'test.jsx': 'javascript-react-test',
    'test.ts': 'typescript-test',
    'test.tsx': 'typescript-react-test',
    'spec.js': 'javascript-test',
    'spec.jsx': 'javascript-react-test',
    'spec.ts': 'typescript-test',
    'spec.tsx': 'typescript-react-test',
    'story.js': 'javascript-story',
    'story.jsx': 'javascript-react-story',
    'story.ts': 'typescript-story',
    'story.tsx': 'typescript-react-story',
    tcl: 'tcl',
    texi: 'tex',
    tex: 'tex',
    bib: 'tex',
    textile: 'textile',
    todo: 'todo',
    twig: 'twig',
    ts: 'typescript',
    vue: 'vue',
    vscodeignore: 'visualstudiocode',
    iml: 'xml',
    xml: 'xml',
    axml: 'xml',
    xaml: 'xml',
    dbml: 'xml',
    lvml: 'xml',
    pex: 'xml',
    yml: 'yaml',
    yaml: 'yaml',
    yarnclean: 'yarn',
    zip: 'zip',
    rar: 'zip',
    '7z': 'zip',
    tar: 'zip',
    gz: 'zip',
    bzip2: 'zip',
    xz: 'zip',
    bz2: 'zip',
    'blade.php': 'blade',
    nsi: 'nsis',
    nsh: 'nsis',
    volt: 'phalcon',
    zep: 'zephir',
    mp3: 'audio',
    wav: 'audio',
    flac: 'audio',
    m4a: 'audio',
    aiff: 'audio',
    wma: 'audio',
    mov: 'video',
    webm: 'video',
    mp4: 'video',
    mpg: 'video',
    mpeg: 'video',
    mkv: 'video',
    flv: 'video',
    vob: 'video',
    ogv: 'video',
    ogg: 'video',
    avi: 'video',
    m4v: 'video',
    qt: 'video',
    mp2: 'video',
    ppt: 'powerpoint',
    pptx: 'powerpoint',
    pptm: 'powerpoint',
    pot: 'powerpoint',
    potx: 'powerpoint',
    pps: 'powerpoint',
    ppsm: 'powerpoint',
    doc: 'word',
    docx: 'word',
    rtf: 'word',
    xls: 'excel',
    xlsx: 'excel',
    csv: 'excel',
    tsv: 'excel',
    cer: 'certificate',
    babelrc: 'babel',
    ino: 'arduino',
    glsl: 'opengl',
    vs: 'opengl',
    frag: 'opengl',
    vert: 'opengl',
    dart: 'dart',
    pp: 'puppet',
    rproj: 'rstudio',
    sol: 'solidity',
    lua: 'lua',
    http: 'server',
    json5: 'json5',
    gql: 'graphql',
    graphql: 'graphql',
    graphqls: 'graphql',
    prettierrc: 'prettier',
    prettierignore: 'prettier',
    m: 'matlab-alt',
    cu: 'cuda',
    kt: 'kotlin',
    kts: 'kotlin',
    fxp: 'foxpro',
    pas: 'pascal',
    dpr: 'pascalproject',
    lpr: 'pascalproject',
    hbp: 'harbour',
    hbc: 'harbour',
    prg: 'exe',
    tf: 'terraform',
    tfvars: 'terraform',
    vb: 'visualbasic',
    rst: 'doc',
    re: 'reason',
    rei: 'reason',
    ipynb: 'jupyter',
    log: 'log',
    lock: 'lock',
    toml: 'toml',
    cr: 'crystal',
    ecr: 'html',
    seedling: 'seedling'
};

export const PANEL_FILE_ICON_THEME_ID: string = 'lvgl-file-icons';
export const PANEL_FILE_ICON_BASE_CLASS: string = 'theia-lvgl-file-icon';

const escapeClassName = (value: string): string => value.replace(/[^-a-zA-Z0-9]/g, '-');

const svgToDataUri = (svg: string): string =>
    `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg.replace(/>\s+</g, '><').trim())}`;

export const getFileIconClassName = (iconName: string): string =>
    `${PANEL_FILE_ICON_BASE_CLASS} ${PANEL_FILE_ICON_BASE_CLASS}--${escapeClassName(iconName)}`;

export const resolveFileIconName = (fileName: string): string => {
    const normalizedFileName: string = fileName.toLowerCase();
    const extension: string = normalizedFileName.split('.').pop() || '';
    const mappedIcon: string = FILE_NAMES[normalizedFileName] || FILE_EXTENSIONS[extension] || 'file';
    return PANEL_ICON_SVGS[mappedIcon] ? mappedIcon : 'file';
};

const iconRules: string = Object.entries(PANEL_ICON_SVGS)
    .map(
        ([
            iconName,
            svg
        ]) => `.${PANEL_FILE_ICON_BASE_CLASS}.${PANEL_FILE_ICON_BASE_CLASS}--${escapeClassName(iconName)}::before {
    background-image: url("${svgToDataUri(svg)}");
}`
    )
    .join('\n');

export const FILE_ICON_THEME_CSS: string = `.${PANEL_FILE_ICON_BASE_CLASS}::before {
    content: ' ';
    display: inline-block;
    width: 16px;
    height: 16px;
    min-width: 16px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: 16px 16px;
    vertical-align: text-bottom;
}

${iconRules}
`;
